import React, { useState, useEffect, useRef } from 'react';
import { getFirestore, Timestamp, doc, setDoc , collection, query, getDocs, where } from "@firebase/firestore";
import { app } from '../../firebase.js';
import { getAuth, onAuthStateChanged } from "firebase/auth";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus} from '@fortawesome/free-solid-svg-icons'

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import ReactPaginate from 'react-paginate';
import Table from 'react-bootstrap/Table';

function OtherIncomeComp() {
    const db = getFirestore(app);
    const auth = getAuth();
    const [modalShowUp, setModalShowUp] = React.useState(false);
    const [branchesList, setBranchesList] = useState([]);
    const [incomeList, setIncomeList] = useState([]);
    const [branchMapping, setBranchMapping] = useState({});


    useEffect(() => {
        const fetchData = async () => {
            const q = query(collection(db, 'otherIncome'));
            const querySnapshot = await getDocs(q);
            const studentsItem = [];
            querySnapshot.forEach((doc) => {
                studentsItem.push({ id: doc.id, ...doc.data() });
                
            });
            setIncomeList(studentsItem);
        };
    
        fetchData();
    }, []);


    useEffect(() => {
        const fetchBranches = async () => {
            const q = query(collection(db, 'Branches'));
            const querySnapshot = await getDocs(q);
            const branches = [];
            const mapping = {};
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                branches.push({ id: doc.id, ...data });
                mapping[doc.id] = data.branchName;
            });
            setBranchesList(branches);
            setBranchMapping(mapping);
        };
    
        fetchBranches();
    }, []);


    function MyUpdateModal(props) {
        return (
          <Modal
            {...props}
            
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Add other income
              </Modal.Title>
            </Modal.Header>
            <Modal.Body> 

            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Select Branch</Form.Label>
                <Form.Select aria-label="Default select example" ref={selectedBranch}>
                {branchesList.map((mybranches) => ( 
                    <option value={mybranches.docID}>{mybranches.branchName}</option>

                ))}
                </Form.Select>
            </Form.Group>
             
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Income Title</Form.Label>
                <Form.Control type="text" ref={incomeTitle}
                />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Income Description</Form.Label>
                <Form.Control type="text" ref={incomeDesc}
                />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Income From</Form.Label>
                <Form.Control type="text" ref={incomeFrom}
                />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Date Received</Form.Label>
                <Form.Control type="datetime-local" ref={dateReceived}
                />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Amount</Form.Label>
                <Form.Control type="number" ref={amountReceived}
                />
            </Form.Group>
    
    
            </Modal.Body>
            <Modal.Footer>
              <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
    
    
                <Button variant="primary"  id='submitBtn' onClick={submitIncome}>
                Submit
                </Button>  
    
    
                <Button variant="primary" disabled id='spinnerbtn' style={{ display : 'none' }}>
                    <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    />
                    <span> Submitting...</span>
                </Button>
                
            </Modal.Footer>
          </Modal>
        );
    }

    const selectedBranch = useRef();
    const incomeTitle = useRef();
    const incomeDesc = useRef();
    const incomeFrom = useRef(); 
    const dateReceived = useRef();
    const amountReceived = useRef();

    function submitIncome(){

        const branch = selectedBranch.current.value;
        const incomeTit = incomeTitle.current.value;
        const incomeDescr = incomeDesc.current.value;
        const incomeFro = incomeFrom.current.value;
        const dateReceivedd = dateReceived.current.value;
        const amount = amountReceived.current.value;
        const timeReceived = new Date(dateReceivedd).getTime();

        document.getElementById("submitBtn").style.display = "none";
        document.getElementById("spinnerbtn").style.display = "block";

        const newDataRef = doc(collection(db, "otherIncome"));
        setDoc(newDataRef, {
          branch: branch,
          incomeTitle: incomeTit,
          incomeDesc: incomeDescr,
          timeCreated: Timestamp.now(),
          dateReceived: Timestamp.fromMillis(timeReceived),
          docID:newDataRef.id,
          incomeFrom:incomeFro,
          amount:amount
        }).then(()=>{
          swal("Success!", "Income added successfully", "success");
          window.location.reload();
        })

    }

    
  return (
    <div className='teamsComponent'>
        
        <div className='teamsTopBar'>
            <h5 className='tHide1'>Other Income</h5>
            <h5 className='tHide2'>Other Income</h5>
            <button className='startOnlSessBtn' onClick={() => setModalShowUp(true)}> <FontAwesomeIcon icon={faPlus} className="liveSessionIcon"/> Add an Income</button>
            <button className='startOnlSessBtn2' onClick={() => setModalShowUp(true)}> <FontAwesomeIcon icon={faPlus} className="liveSessionIcon"/> Add an Income</button>
        </div>
        <br />

        <Table striped bordered hover>
            <thead>
              <tr>
                <th>Income Date</th>
                <th>Income Title</th>
                <th>Income Description</th>
                <th>Income From</th>
                <th>Amount</th>
                <th>Branch</th>
              </tr>
            </thead> 
            <tbody>
              {incomeList.map((mystudent) => (
                <tr key={mystudent.id}>
                  <td>{mystudent.dateReceived.toDate().toDateString()} </td>
                  <td>{mystudent.incomeTitle}</td>
                  <td>{mystudent.incomeDesc}</td>
                  <td>{mystudent.incomeFrom}</td>
                  <td>KES. {parseFloat(mystudent.amount).toLocaleString()}</td>
                  <td>{branchMapping[mystudent.branch]}</td>
                </tr>
              ))}
            </tbody>
          </Table>


        <MyUpdateModal show={modalShowUp} onHide={() => setModalShowUp(false)} />
    </div>
  )
}

export default OtherIncomeComp